module.exports = __webpack_public_path__ + "img/implem.12928b10.png";